import React, { useState, useEffect } from 'react';
import { RedAsterisk } from '../input';
import { theme } from '../theme';
import { Tooltip } from '../tooltip';
import { CustomSelectProps, Select } from './Select';
import {
  SelectLabel,
  StyledSelectWithLabel,
  StyledTooltipIcon,
} from './styled';

export interface SelectWithLabelProps extends CustomSelectProps {
  label: React.ReactNode;
  labelTooltip?: React.ReactNode;
}

export const SelectWithLabel: React.FC<SelectWithLabelProps> = ({
  label,
  labelTooltip,
  ...props
}) => {
  const [filledSelect, setFilledSelect] = useState(false);

  useEffect(() => {
    setFilledSelect(!!(props.defaultValue && props.defaultValue !== ''));
  }, [props.defaultValue]);

  const handleSelectedValue = (values: any) => {
    setFilledSelect(!!values);
  };

  return (
    <StyledSelectWithLabel filled={filledSelect}>
      <SelectLabel
        disabled={props.disabled}
        readOnly={props.readOnly}
        filled={filledSelect}>
        {label}
        {props.required && <RedAsterisk />}
        {labelTooltip && (
          <Tooltip
            placement="topRight"
            title={labelTooltip}
            color={theme.colors.primaryK10}>
            <StyledTooltipIcon />
          </Tooltip>
        )}
      </SelectLabel>
      <Select {...props} onSelectedValue={handleSelectedValue} />
    </StyledSelectWithLabel>
  );
};
